export default "__VITE_ASSET__DdIyqsBu__"